<template>
  <div>
    <h1 class="text-center h1">APP教学视频</h1>
    <p class="text-center text-p">您可以点击下面的视频，查看并学习“玩转工厂”的<br />使用方法里面涵盖了APP的功能，以及基本操作方式，让您快速掌握我们的APP</p>
    <div class="text-center div-video">
      <video class="video" controls="controls">
        <source src="http://www.w3school.com.cn/i/movie.ogg" type="video/ogg">
        <source src="http://www.w3school.com.cn/i/movie.mp4" type="video/mp4">
      </video>
    </div>
    <p class="text-center text-p">零成本学习如何更快捷、效率的管理工场</p>
  </div>
</template>

<script>
export default {
  name: 'HomeContentTeaching'
}
</script>

<style lang="stylus" scoped>
.h1
  padding-top 5rem
  color #333333
  font-size: 1.9rem;
  line-height: 0.9rem
  letter-spacing: 0rem
.text-p
  padding-top 2rem
  font-size 0.9rem
  line-height 1.3rem
  letter-spacing 0rem
  color #666666
.video
  width 37.5rem
  height 21.6rem
  background-color #020000
</style>



// WEBPACK FOOTER //
// src/pages/home/components/ContentTeaching.vue